import { ShieldCheck, Droplets } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="mb-4">
            <span className="inline-flex bg-white rounded-xl p-2">
              <img src="/logo.jpg" alt="Solar Stars LLC" className="h-16 w-auto object-contain" />
            </span>
          </div>
          <p className="text-sm text-slate-400 max-w-md leading-relaxed">
            Veteran-owned solar panel cleaning with military precision. Pure deionized water, streak-free guarantee, and every panel treated like mission-critical gear.
          </p>
          <div className="flex flex-wrap gap-3 mt-5">
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold bg-slate-800 px-3 py-1.5 rounded-full">
              <ShieldCheck className="w-3.5 h-3.5 text-amber-400" /> Veteran-Owned
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold bg-slate-800 px-3 py-1.5 rounded-full">
              <Droplets className="w-3.5 h-3.5 text-emerald-400" /> Pure Water · Streak-Free
            </span>
          </div>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Services</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>Residential Solar Cleaning</li>
            <li>Bi-Annual Maintenance Plans</li>
            <li>Bird Guard Installation</li>
            <li>Moss &amp; Lichen Removal</li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Contact</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>(813) 203-1001</li>
            <li>solarstarsllc2022@gmail.com</li>
            <li>Mon–Sat · 7am–6pm</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Stars Cleaning Solar Care · Proudly Veteran-Owned &amp; Operated
      </div>
    </footer>
  );
}
